import React, { useState, useEffect } from 'react';
import withStyles from 'react-jss';
import AssetList from '../Asset/AssetList';
import StorageAddForm from './StorageAddForm';
import Modal from '../../components/Modal/Modal';
import { Link } from 'react-router-dom';
import { useDecoratedAssetsByStorageIds } from '../../services/Firestore/Resources';
import Input from '../../components/Input/Input';
import { StorageTitle } from '../../components/Title/StorageTitle/StorageTitle';
import Entity from '../../components/Entity/Entity';
import { AssetOwnerType } from '../../constants';
import { Icon } from '../../components/Icon/Icon';

const styles = {
  root: {
    display: 'grid',
  },
  link: {
    cursor: 'pointer',
    fontStyle: 'italic',
    color: 'var(--third-color)',
  },
  storageLink: {
    cursor: 'pointer',
  },
  assetTitle: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
  },
  search: {
    justifySelf: 'self-end',
    margin: 10,
    display: 'grid',
    gridTemplateColumns: 'auto auto',
  },
  columnFilter: {
    cursor: 'pointer',
    margin: 10,
  },
};

const Storage = ({ classes, storage, storages, storageIds }) => {
  const [showAdd, setShowAdd] = useState(false);
  const [q, setQ] = useState('');
  const [columnFilter, setColumnFilter] = useState(false);
  const [assets, assetsLoading] = useDecoratedAssetsByStorageIds(storageIds);
  const [lineages, setLineages] = useState('');
  let space = 0;

  function renderSpace(increment) {
    let spaces = '';
    let i = 0;
    while (i < space) {
      spaces += '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0';
      i++;
    }
    if (increment) {
      space += 1;
    }
    return spaces;
  }

  useEffect(() => {
    let topLineages = [];
    let children = [];
    //Shows lineage from rootstorage down to position of storage youre in.
    for (let i = 0; i < storage.lineage.length; i++) {
      topLineages.push(
        <div key={storage.lineage[i]}>
          <span>{renderSpace(true)}</span>
          {storage.lineage[i] !== storage.id ? (
            <Link to={'/storages/' + storage.lineage[i]}>
              <Entity title={storage.lineageNames[i]} />
            </Link>
          ) : (
            <span>{storage.lineageNames[i]}</span>
          )}
        </div>,
      );
    }
    if (storages != null && storages.length > 0) {
      //shows all children to storage youre in.
      if (storage.lineage) {
        Object.values(storages)
          .filter((s) => storage.id === s.parent && !s.deleted)
          .map((s) =>
            children.push(
              <div key={s.id}>
                <span>{renderSpace(false)}</span>
                <Link to={'/storages/' + s.id}>{s.name}</Link>
              </div>,
            ),
          );
      }
    }
    setLineages({ topLineages, children });
  }, [storage, storages]);
  //will remove assets that are not below your current storage
  function limitAssets(assets) {
    return Object.values(assets).filter(
      (v) => v.storageId && v.storage.lineage.includes(storage.id),
    );
  }

  if (assetsLoading || lineages === '') return 'Loading...';

  return (
    <div className={classes.root}>
      <div>
        {lineages.topLineages}
        {lineages.children}

        <div>
          <span>{renderSpace(false)}</span>
          {!storage.deleted && storage.ownerType !== AssetOwnerType && (
            <span
              className={classes.link}
              onClick={() => {
                setShowAdd(true);
              }}
            >
              Add new storage here
            </span>
          )}
          <Modal open={showAdd} onClose={() => setShowAdd(false)}>
            <StorageAddForm parent={storage.id} onSubmit={() => setShowAdd(false)} />
          </Modal>
        </div>
      </div>
      <div className={classes.assetTitle}>
        <h2>
          Assets within <StorageTitle full={true} {...storage} />
        </h2>
        <div className={classes.search}>
          <Input
            className={classes.search}
            placeholder='Filter'
            defaultValue={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <div>
            {!columnFilter ? (
              <Icon
                className={classes.columnFilter}
                title='Show custom filtering'
                onClick={() => setColumnFilter(true)}
              >
                search
              </Icon>
            ) : (
              <Icon
                className={classes.columnFilter}
                title='Hide custom filtering'
                onClick={() => setColumnFilter(false)}
              >
                search_off
              </Icon>
            )}
          </div>
        </div>
      </div>
      <AssetList assets={limitAssets(assets)} filter={q} columnFilter={columnFilter} />
    </div>
  );
};

export default withStyles(styles)(Storage);
